import React from 'react'
import { AmchartSeeker } from '@ui-seeker/core'
import { AppResultsSkeleton } from '@components'
import { useSearchAnalyticsMonthInfo } from 'Pages/Main/Home/@hooks'


export default function SearchAnalyticsHomeColumnsChart() {

	const { columnChartData, isMonthLoading } = useSearchAnalyticsMonthInfo()

	if (isMonthLoading) return <AppResultsSkeleton chart height="calc(26vw - 82px)"/>

	return <AmchartSeeker
		title="Current Month Searches vs. Previous Month Searches"
		rootID="SearchAnalyticsBarChart"
		sx={{ height: '21vw' }}
		data={columnChartData?.results}
		series={columnChartData?.series?.map(({ dataKey, label, color }) => {
			const key = dataKey === "searches" ? "date" : "previousDate"
			const value = dataKey === "searches" ? "searches" : "previousSearches"
			return {
				type: "column",
				name: label,
				yField: dataKey,
				xField: 'date',
				color: color,
				tooltip: {
					tooltipVisibleOnZero: true,
					isDateAxis: true,
					labelText: `[bold]{${key}.formatDate('dd MMM yyyy')}:[/] {${value}.formatNumber('#,###')}`,
				}
			}
		})}
		chartProps={{
			dateFormatReceived: 'yyyy-MM-dd',
			legend: {
				verticalLayout: false,
				valueLabels: {
					textAlign: "right"
				}
			},
			xAxis: {
				categoryField: 'date',
				isDateAxis: true,
				dateFormat: 'dd MMM yyyy',
				hiddenTooltip: true,
			},
			yAxis: {
				title: 'N° of Searches',
				numberFormat: '# a'
			},
			scrollbarX: { hidden: true },
			enabledPDF: false
		}}
	/>
}